<template>
    <div v-if="onboardingTasks.length > 0" class="onboarding-todo">
        <button
            class="onboarding-todo__toggle"
            :class="{ 'onboarding-todo__toggle--active': isModalOpen }"
            @click="() => (isModalOpen = !isModalOpen)"
        ></button>

        <div v-show="isModalOpen" class="onboarding-todo__modal">
            <span class="onboarding-todo__modal-header"> KOM IGÅNG MED FALAGRETT </span>
            <span class="onboarding-todo icon-circle-cross" @click="() => (isModalOpen = false)"></span>
            <TodoListItem
                v-for="(task, i) in onboardingTasks"
                :key="i"
                :task-nr="i + 1"
                :title="task.title"
                :desc="task.desc"
                :link-header="task.linkHeader"
                :link="task.link"
                :complete-requirement="task.requirement"
                :is-active="task.requirement === activeTask"
                @get-active-step="(stepRequirement) => setActiveTask(stepRequirement)"
            />
        </div>
    </div>
</template>

<script>
    import TodoListItem from '@components/Employ/OnboardingTodoList/TodoListItem.vue';
    import { ref, watch } from 'vue';
    import { DepartmentType } from '@enums/DepartmentType';
    import { ROLES } from '@/helpers';

    export default {
        components: {
            TodoListItem,
        },
        props: {
            role: {
                type: Object,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
            features: {
                type: Array,
                required: true,
                default: () => [],
            },
        },
        setup(props) {
            const isModalOpen = ref(false);
            const activeTask = ref(null);
            const onboardingTasks = ref([]);

            const setActiveTask = (index) => (activeTask.value = index);

            const refreshTasks = () => {
                if (props.type === DepartmentType.Employ && props.role.id === ROLES.ORGANIZATION_ADMIN) {
                    onboardingTasks.value = [
                        {
                            title: 'Skapa intern kompetens',
                            desc: 'Du har möjlighet att skapa egna interna kompetenser. För att skapa kompetenser, gå till "Kompetenser" i menyn. Du kan ange kompetensnamnet, en beskrivning, och giltighetstid.',
                            linkHeader: 'Skapa kompetens',
                            link: { name: 'employ-competences', hash: '#internal' },
                            requirement: 'competences',
                        },
                        {
                            title: 'Lägg till medarbetare',
                            desc: 'För att lägga till dina medarbetare, gå till "Medarbetare" i menyn. Här kan du lägga till en och en eller med filuppladdning. Du kan även bjuda in medarbetare via e-post, de kommer då att få en inbjudan till att registrera sig i systemet.',
                            linkHeader: 'Lägg till medarbetare',
                            link: { name: 'employ-employees', hash: '#users' },
                            requirement: 'employees',
                        },
                        {
                            title: 'Utfärda certifikat',
                            desc: 'Under "Utfärda certifikat" kan du lägga till både interna och externa kompetenser på medarbetare. Du väljer vilka kompetenser de ska certifieras med och detaljer om certifieringen. Du kan också ladda upp certifikatskopia om det finns.',
                            linkHeader: 'Utfärda certifikat',
                            link: 'employ-create-certificate',
                            requirement: 'certificate',
                        },
                    ];

                    if (props.features.find((f) => f.name === 'employExpertise')) {
                        onboardingTasks.value.splice(1, 0, {
                            title: 'Skapa ny roll',
                            desc: 'Roller kan innehålla både era interna kompetenser och externa kompetenser. Genom att koppla dina medarbetare till en roll kan du se och planera utbildningsbehov för alla i den rollen. Du håller även reda på om kompetens som krävs i rollen håller på att förfalla.',
                            linkHeader: 'Skapa roll',
                            link: { name: 'employ-competences', hash: '#expertise' },
                            requirement: 'expertises',
                        });
                    }

                    if (props.features.find((f) => f.name === 'employTeams')) {
                        onboardingTasks.value.splice(3, 0, {
                            title: 'Skapa team',
                            desc: 'Samla dina medarbetare i team för att få överblick över kompetensen i de olika delarna av organisationen.',
                            linkHeader: 'Skapa team',
                            link: { name: 'employ-employees', hash: '#teams' },
                            requirement: 'teams',
                        });
                    }
                }
            };

            watch([() => props.role, () => props.type, () => props.features], refreshTasks, { immediate: true });

            return {
                onboardingTasks,
                isModalOpen,
                activeTask,
                setActiveTask,
            };
        },
    };
</script>

<style scoped lang="scss">
    .icon-circle-cross {
        content: url('/images/x-circle-border.svg');
        width: 24px;
        height: 24px;
        cursor: pointer;

        align-self: flex-end;
        position: relative;
        top: -16px;
    }
    .onboarding-todo__modal-header {
        align-self: flex-start;
    }
</style>
